import React from 'react';
import { Section } from './Shared';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TargetAudience() {
  const forYou = ['Tienes más de 40 años y nunca has revisado tu historia laboral en detalle.', 'Estás a menos de 15 años de pensionarte y quieres tomar decisiones con información real.', 'Sientes que en tu historial laboral pueden faltar semanas de empresas anteriores.', 'Ganas más de 3 salarios mínimos y te preocupa la caída de ingresos al jubilarte.', 'Recibiste la Doble Asesoría obligatoria y saliste más confundido que cuando entraste.', 'Quieres saber si te conviene trasladarte de régimen antes de tomar esa decisión.', 'Simplemente quieres saber con cuánto contarás el día que decidas descansar.'];
  const notForYou = ['Buscas asesoría genérica que no considera tu historial específico.', 'Quieres que alguien tome la decisión por ti sin explicarte los números.', 'No estás dispuesto a compartir tu historia laboral para el análisis.'];
  return <Section bg="slate" data-id="element-172">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-173">
        {/* For You */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200" data-id="element-174">
          <h3 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-175">
            Este servicio es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-176">
            {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-177">
                <CheckCircle2 className="w-5 h-5 text-[#25D366] mt-0.5 flex-shrink-0" data-id="element-178" />
                <span className="text-slate-700" data-id="element-179">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200" data-id="element-180">
          <h3 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-181">
            Este servicio NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-182">
            {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-183">
                <XCircle className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-184" />
                <span className="text-slate-700" data-id="element-185">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}